import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLazyQuery, gql } from '@apollo/client'
import moment from 'moment'

import HeaderExportButton from 'components/global/Buttons/HeaderExportButton'
import { useSites, useUser } from 'store'
import { downloadBase64 } from 'utils'
import { useGetStatsTimeRange } from '../store'
import { convertDateRange } from '../hooks/use-traffic'

const OPERATION_TRAFFIC_EXPORT = gql`
  query trafficExport($ids: [ID], $language: String, $startsAt: String, $endsAt: String) {
    base64: trafficExport(sf_ids: $ids, language: $language, starts_at: $startsAt, ends_at: $endsAt)
  }
`

const Export = () => {
  const { t } = useTranslation()
  const { i18n } = useTranslation()
  const [user] = useUser()
  const [{ selected }] = useSites()
  const [timeRange] = useGetStatsTimeRange()
  const siteSfIds = useMemo(
    () => (selected ? selected.map(({ sf_id }) => sf_id) : []),
    [selected],
  )
  
  const [launchExport, { loading }] = useLazyQuery(OPERATION_TRAFFIC_EXPORT)

  const handleClick = async () => {
    const { startsAt, endsAt } = convertDateRange(timeRange)
    const { data: { base64 } } = await launchExport({ variables: { ids: siteSfIds, language: i18n.language, startsAt, endsAt } })
    await downloadBase64({ base64, fileName: `stats_wifi_${moment().format('DD/MM/YYYY')}.xls`})
  }

  return (
    <HeaderExportButton
      analyticsName="stats_traffic"
      onClick={handleClick}
      disabled={Boolean(user?.demo_mode)}
      loading={loading}
      loadingLabel={t('ui_elements.in_progress')}
    >
      {t('export.button')}
    </HeaderExportButton>
  )
}


export default Export
